<template>
                    
                           
<section class="login" :style="{
    'background-image': 'url(' + backgroundImage + ')'
  }">
  <header-logged-out :type="type"></header-logged-out>
  <v-container fill-height>
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <v-card>
          <form @submit.prevent="submit">
            <v-toolbar dark color="primary" flat>
              <v-toolbar-title>{{ label }} Login</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-text-field v-model="cred" v-validate="
                  credLabel === 'E-mail'
                    ? 'email|required|max:150'
                    : 'required|max:150'
                " :error-messages="errors.collect('cred')" :label="credLabel" :hint="
                  `Enter your ${
                    credLabel === 'E-mail'
                      ? 'username or email'
                      : 'student code'
                  } you used when you registered`
                " data-vv-name="cred" data-vv-as="username or email" required></v-text-field>
              <v-text-field v-model="password" name="password" label="Enter your password" hint="Make sure your password is 6 to 20 characters long" min="6" :append-icon="visible ? 'visibility' : 'visibility_off'" @click:append="visible = !visible" :error-messages="errors.collect('password')" v-validate="'required|min:6|max:20'" data-vv-name="password" required :type="visible ? 'text' : 'password'"></v-text-field>
              <template>
    <router-link to="/student/forgotpassword" style="color: #1565c0">
      Forgot password?
    </router-link>
  </template>
            </v-card-text>
            <v-card-actions class="px-3 pb-3 pt-0">
              <template>
                <div>
                  First time here?
                  <router-link :to="`/${type}/signup`" style="color: #1565c0">
                    Create an account.
                  </router-link>
                </div>
              </template>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" :loading="loading" :disabled="loading">
                Login
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
        <custom-snackbar></custom-snackbar>
      </v-col>
    </v-row>
  </v-container>
</section>

                         
                  </template> 
                  <script >
import Student from '@/modules/student/models/Student'
import Login from '@/modules/auth/views/Login'

export default {
  name: 'StudentLogin',
  extends: Login,
  data() {
    return {
      type: 'student',
      label: 'Student',
      credLabel: 'Student Code'
    }
  },
  computed: {
    backgroundImage() {
      return this.bucketUrl + '/assets/background_student.png'
    }
  },
  methods: {
    async dispatchMethod(form) {
      await Student.dispatch('login', {
        payload: form
      })
    }
  }
}
</script>